import React from 'react';
import classnames from 'classnames';
import baseStyles from 'custom/base.styl';

const PASSING_SCORE = 11;

const SubjectTestFailed = ({ timeout, score }) => {
  return (
    <div>
      {timeout &&
        <h3 className={classnames(baseStyles.title_small, baseStyles.text_danger, baseStyles.left, baseStyles.mb_15)}>You’ve run out of time</h3>
      }
      {!timeout &&
        <h3 className={classnames(baseStyles.title_small, baseStyles.text_danger, baseStyles.left, baseStyles.mb_15)}>You have failed the subject test.</h3>
      }
      <p className={classnames(baseStyles.title_extra_small, baseStyles.left, baseStyles.mb_20)}>
        You've scored <b>{score}</b> out of 15, while the passing score is {PASSING_SCORE}.
      </p>
      <p className={classnames(baseStyles.title_extra_small, baseStyles.left, baseStyles.mb_20)}><b>Please note:</b> per our company policy, we cannot share our test questions, as well as correct answers to it.</p>
      <p className={classnames(baseStyles.title_extra_small, baseStyles.left, baseStyles.mb_20)}>
        Unfortunately, we cannot offer you a position right now. Please improve your skills and we will be glad to see you reapplying in the next three months
      </p>
    </div>
  );
};

export default SubjectTestFailed;



// WEBPACK FOOTER //
// ./src/components/ApplicationOverview/SubjectTestFailed.js